const API_BASE = process.env.REACT_APP_API_BASE || '';

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, { credentials: 'include', ...options });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || `Request failed (${response.status})`);
  return body;
}

export function listMatters(query = '') {
  const suffix = query ? `?q=${encodeURIComponent(query)}` : '';
  return request(`/api/matters${suffix}`);
}

export function getMatter(matterId) {
  return request(`/api/matters/${encodeURIComponent(matterId)}`);
}

export function getMatterPlaybook(matterId) {
  return request(`/api/matters/${encodeURIComponent(matterId)}/playbook`);
}

export function createMatter(input) {
  return request('/api/matters', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function updateMatter(matterId, input) {
  return request(`/api/matters/${encodeURIComponent(matterId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function uploadEvidence(matterId, file, metadata = {}) {
  const form = new FormData();
  form.append('file', file);
  Object.entries(metadata).forEach(([key, value]) => {
    if (value != null && value !== '') form.append(key, value);
  });
  return request(`/api/matters/${encodeURIComponent(matterId)}/evidence`, {
    method: 'POST',
    body: form,
  });
}

export function createMatterRecord(matterId, collection, input) {
  return request(`/api/matters/${encodeURIComponent(matterId)}/${collection}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function updateFact(matterId, factId, input) {
  return request(`/api/matters/${encodeURIComponent(matterId)}/facts/${encodeURIComponent(factId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function updateIssue(matterId, issueId, input) {
  return request(`/api/matters/${encodeURIComponent(matterId)}/issues/${encodeURIComponent(issueId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function updateTask(matterId, taskId, input) {
  return request(`/api/matters/${encodeURIComponent(matterId)}/tasks/${encodeURIComponent(taskId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function approveRecord(matterId, input) {
  return request(`/api/matters/${encodeURIComponent(matterId)}/approvals`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function analyzeEvidence(matterId, evidenceIds) {
  return request(`/api/matters/${encodeURIComponent(matterId)}/analyze`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ evidenceIds, confirmConfidentialProcessing: true }),
  });
}

export function transcribeEvidence(matterId, evidenceId) {
  return request(`/api/matters/${encodeURIComponent(matterId)}/evidence/${encodeURIComponent(evidenceId)}/transcribe`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ confirmConfidentialProcessing: true }),
  });
}

export function getAudit(matterId) {
  return request(`/api/matters/${encodeURIComponent(matterId)}/audit`);
}

export function evidenceDownloadUrl(matterId, evidenceId) {
  return `${API_BASE}/api/matters/${encodeURIComponent(matterId)}/evidence/${encodeURIComponent(evidenceId)}/download`;
}
